import { fetchManager } from '../utils/fetchManager';

export const wcoxmlwebService = {
  loadWcoXmlWebData: companyId => fetchManager('get', `wcoxml_web/${companyId}/analytics`),
  exportCompanyWcoXmlWebConfig: companyId => fetchManager('get', `wcoxml_web/${companyId}/export`),
};
